// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3ZW7y","errorLogs":"styles_errorLogs__1OVjS"};